module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.dcf628f6.ttf";